import Tooltip from '@material-ui/core/Tooltip';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import withGS from '../core/withGShoc';
import PropTypes from 'prop-types';
import React from 'react';
import { isRTL } from '../core/utils/utils';

class ComponentSelectorMenuItem extends React.Component {

    render() {

        const { data, defaultLang, id, displayWorkflow } = this.props;

        const label = data.title && data.title[defaultLang] ?
            data.title[defaultLang]
            :
            data.title && data.title["und"] ?
                data.title && data.title["und"]
                :
                id;
        const rtl = data.title && data.title[defaultLang] && isRTL(defaultLang);

        const labelSpan = <span
            dir={rtl ? "rtl" : null}
            style={{ width: '95%', overflow: 'hidden' }} data-test="component-title">
            <span>{label}</span>
            {
                data.activateWorkflow && displayWorkflow &&
                <span style={{ marginLeft: 6, float: 'right', marginRight: 6 }}>
                    <Tooltip title="Workflow is activated">
                        <AssignmentTurnedInIcon data-test="workflow-activated" style={{ verticalAlign: 'middle', fontSize: '1rem' }} />
                    </Tooltip>
                </span>
            }</span>;

        return (
            labelSpan
        );
    }
}

ComponentSelectorMenuItem.defaultProps = {
    displayWorkflow: false
};

ComponentSelectorMenuItem.propTypes = {
    id: PropTypes.string.isRequired,
    displayWorkflow: PropTypes.bool,
    data: PropTypes.object.isRequired,
    defaultLang: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withGS(ComponentSelectorMenuItem, ["ALL"], null, {});